import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as service from "./service";
import * as types from "./types";


/*
  Worker Saga: Fired on FETCH_SchemaSelection_REQUEST action
*/
function* fetchGroupSaga(action: types.FetchGroupUsersRequest) {
  try {
    const response: AxiosResponse<types.IUser[]> = yield call(service.getGroupUsers, action.group);

    yield put(
      actions.fetchGroupUsersSuccess(action.group, {
        userName: response.data
      })
    );
  } catch (e: any) {
    yield put(
      actions.fetchGroupUsersFailure(action.group, {
        error: e.message
      })
    );
  }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_GROUP_USERS_REQUEST` action.
  Allows concurrent increments.
*/
function* groupDataSaga() {
  yield all([
    takeEvery(actionTypes.FETCH_GROUP_USERS_REQUEST, fetchGroupSaga),
  ]);
}

function* groupsSaga() {
  yield all([
      groupDataSaga()
  ])
}

export default groupsSaga;